// extracted by mini-css-extract-plugin
module.exports = {"GenericButton":"styles_GenericButton__2Ket7","GenericButton-icon":"styles_GenericButton-icon__5jq2A"};